import { inject, Injectable } from '@angular/core';
import { ConfigOption, FormlyFieldConfig } from '@ngx-formly/core';
import { FormlyFieldConfigPresetProvider } from '@ngx-formly/core/lib/models';
import { DataSetupFacade } from '@portal/application/data-access';
import { map } from 'rxjs';
import { mapDataSetupSelectOptionToFormly } from '../util';

@Injectable()
export class MaritalStatusPresetProvider implements FormlyFieldConfigPresetProvider {
  private readonly dataSetupFacade = inject(DataSetupFacade);

  getConfiguration(): FormlyFieldConfig {
    return {
      type: 'mat-select',
      props: {
        label: 'Marital Status',
        placeholder: 'Please Select',
        options: this.dataSetupFacade.dataSetup$?.pipe(
          map(dataSetup => mapDataSetupSelectOptionToFormly(dataSetup?.keyPersonnelMaritalStatus)),
        ),
      },
    };
  }
}

export function registerMaritalStatusPreset(): ConfigOption {
  return { presets: [{ name: 'maritalStatus', config: new MaritalStatusPresetProvider() }] };
}
